type LogMethod = "warn" | "error";

function log(method: LogMethod, scope: string, message: string, ...args: unknown[]): void {
  if (!import.meta.env.DEV) return;
  console[method](`[${scope}] ${message}`, ...args);
}

/** Development-only logging — no-ops in production builds. */
export const logger = {
  warn(scope: string, message: string, ...args: unknown[]): void {
    log("warn", scope, message, ...args);
  },
  error(scope: string, message: string, ...args: unknown[]): void {
    log("error", scope, message, ...args);
  },
};
